import { z as t } from "zod";
import s from "./ScalarPageTitle.vue.js";
import { createEditorVueNode as m } from "../../../helpers/nodeFactory.js";
import { renderVueElement as n } from "../../../helpers/staticRendering.js";
import i from "./CustomPageTitle.vue.js";
const e = "custom_page_title", f = {
  tagName: e,
  attributeTransform: (r, a) => {
    const o = t.object({
      title: t.string(),
      description: t.string().default("")
    }).safeParse(a);
    return o.success ? o.data : null;
  }
}, g = {
  name: e,
  render: (r) => n(s, { ...r })
}, _ = m(
  {
    name: e,
    vueComponent: i,
    draggable: !1
  },
  {
    group: "block",
    atom: !0,
    selectable: !1,
    parseHTML() {
      return [
        {
          tag: "custom_page_title"
        }
      ];
    }
  }
);
export {
  g as customPageTitleStatic,
  _ as default,
  f as markdownPageTitle
};
